module.exports = __webpack_public_path__ + "img/Hotmart-6-es.26819408.png";